import React from 'react';
import ReactDOM from 'react-dom';
import { ConfigProvider } from 'antd';
import zhcn from 'antd/lib/locale/zh_CN'
import App from './App.jsx';

ReactDOM.render(
  <ConfigProvider locale={zhcn}>
    <App />
  </ConfigProvider>,
  document.getElementById('root')
);

